import { useMemo } from 'react';
import { useReactiveVar } from '@apollo/client';
import {
  shoppingCartOffersVar,
  offerSelectedClientsVar,
} from '../../../apollo/reactive-variables/shopping-cart';
import MY_CLIENTS from '../../../graphql/queries/factoring/my-clients';

const useAvailableOffersStepsBase = ({
  DateSelectionStepComponent,
  CessionStepComponent,
  countryConfig,
  tutorial,
  stepsConditions,
  setShowConfirmationSummary,
  setShowCessionStep,
  SummaryComponent,
  isBlocked,
  unavailabilityCode,
  getShoppingCartProps,
  showGoBackButton = false,
  getClientColumns,
  getDetailsColumns,
  detailsHeaders,
  detailsMobileHeaders,
  getInformationStackText,
}) => {
  const shoppingCartOffers = useReactiveVar(shoppingCartOffersVar);
  const clientOffers = useReactiveVar(offerSelectedClientsVar);
  const offerIds = shoppingCartOffers.map((offer) => offer.invoiceId);
  const { headers } = countryConfig;
  const clientsIds = useMemo(() => Object.keys(clientOffers), [clientOffers]);
  const { hook } = tutorial;
  const { activeStep } = hook(stepsConditions);

  const isActionDisabled = useMemo(
    () => shoppingCartOffers.some((off) => off.dateToPay === null),
    [shoppingCartOffers],
  );

  const configurationIndexToShow = useMemo(() => {
    if (activeStep < 2) {
      return 0;
    }
    return 1;
  }, [activeStep]);

  const stepsConfiguration = useMemo(() => [
    {
      component: DateSelectionStepComponent,
      props: {
        clientsIds,
        offerIds,
        headers,
        isActionDisabled,
        setShowConfirmationSummary,
        setShowCessionStep,
        MY_CLIENTS,
        countryConfig,
        SummaryComponent,
        isBlocked,
        unavailabilityCode,
        showGoBackButton,
        getClientColumns,
        getDetailsColumns,
        detailsHeaders,
        detailsMobileHeaders,
        getInformationStackText,
      },
    },
    {
      component: CessionStepComponent,
      props: {
        setShowCessionStep,
        countryConfig,
        getShoppingCartProps,
        showGoBackButton,
      },
    },
  ], [
    DateSelectionStepComponent,
    CessionStepComponent,
    clientsIds,
    offerIds,
    headers,
    isActionDisabled,
    setShowConfirmationSummary,
    setShowCessionStep,
    countryConfig,
    SummaryComponent,
    isBlocked,
    unavailabilityCode,
    getShoppingCartProps,
    showGoBackButton,
    getClientColumns,
    getDetailsColumns,
    detailsHeaders,
    detailsMobileHeaders,
    getInformationStackText,
  ]);

  return stepsConfiguration[configurationIndexToShow];
};

export default useAvailableOffersStepsBase;
